/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BidderDto } from '../models/bidder-dto';
import { findBidders } from '../fn/bidder/find-bidders';
import { FindBidders$Params } from '../fn/bidder/find-bidders';
import { FindBiddersResponseDto } from '../models/find-bidders-response-dto';
import { getBidder } from '../fn/bidder/get-bidder';
import { GetBidder$Params } from '../fn/bidder/get-bidder';
import { getBidderCustomIdMappingCsv } from '../fn/bidder/get-bidder-custom-id-mapping-csv';
import { GetBidderCustomIdMappingCsv$Params } from '../fn/bidder/get-bidder-custom-id-mapping-csv';
import { getBidderStatsExcel } from '../fn/bidder/get-bidder-stats-excel';
import { GetBidderStatsExcel$Params } from '../fn/bidder/get-bidder-stats-excel';
import { getHighestBidsPerBidderCsv } from '../fn/bidder/get-highest-bids-per-bidder-csv';
import { GetHighestBidsPerBidderCsv$Params } from '../fn/bidder/get-highest-bids-per-bidder-csv';
import { patchBidder } from '../fn/bidder/patch-bidder';
import { PatchBidder$Params } from '../fn/bidder/patch-bidder';

@Injectable({ providedIn: 'root' })
export class GeneratedBidderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findBidders()` */
  static readonly FindBiddersPath = '/api/bidders';

  /**
   * Finds bidders by a given filter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findBidders()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBidders$Response(params: FindBidders$Params, context?: HttpContext): Observable<StrictHttpResponse<FindBiddersResponseDto>> {
    return findBidders(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds bidders by a given filter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findBidders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBidders(params: FindBidders$Params, context?: HttpContext): Observable<FindBiddersResponseDto> {
    return this.findBidders$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindBiddersResponseDto>): FindBiddersResponseDto => r.body)
    );
  }

  /** Path part for operation `getBidder()` */
  static readonly GetBidderPath = '/api/bidders/{id}';

  /**
   * Gets a bidder by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidder$Response(params: GetBidder$Params, context?: HttpContext): Observable<StrictHttpResponse<BidderDto>> {
    return getBidder(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a bidder by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidder(params: GetBidder$Params, context?: HttpContext): Observable<BidderDto> {
    return this.getBidder$Response(params, context).pipe(
      map((r: StrictHttpResponse<BidderDto>): BidderDto => r.body)
    );
  }

  /** Path part for operation `patchBidder()` */
  static readonly PatchBidderPath = '/api/bidders/{id}';

  /**
   * Patches a bidder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchBidder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchBidder$Response(params: PatchBidder$Params, context?: HttpContext): Observable<StrictHttpResponse<BidderDto>> {
    return patchBidder(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches a bidder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchBidder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchBidder(params: PatchBidder$Params, context?: HttpContext): Observable<BidderDto> {
    return this.patchBidder$Response(params, context).pipe(
      map((r: StrictHttpResponse<BidderDto>): BidderDto => r.body)
    );
  }

  /** Path part for operation `getBidderCustomIdMappingCsv()` */
  static readonly GetBidderCustomIdMappingCsvPath = '/api/bidders/auction/{auctionId}/bidder-customid-mapping';

  /**
   * Gets a CSV mapping of bidder numbers to user CustomIds for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidderCustomIdMappingCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderCustomIdMappingCsv$Response(params: GetBidderCustomIdMappingCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getBidderCustomIdMappingCsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a CSV mapping of bidder numbers to user CustomIds for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidderCustomIdMappingCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderCustomIdMappingCsv(params: GetBidderCustomIdMappingCsv$Params, context?: HttpContext): Observable<Blob> {
    return this.getBidderCustomIdMappingCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getHighestBidsPerBidderCsv()` */
  static readonly GetHighestBidsPerBidderCsvPath = '/api/bidders/auction/{auctionId}/highest-bids-per-bidder';

  /**
   * Gets a CSV export of highest bids per bidder for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHighestBidsPerBidderCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHighestBidsPerBidderCsv$Response(params: GetHighestBidsPerBidderCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getHighestBidsPerBidderCsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a CSV export of highest bids per bidder for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHighestBidsPerBidderCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHighestBidsPerBidderCsv(params: GetHighestBidsPerBidderCsv$Params, context?: HttpContext): Observable<Blob> {
    return this.getHighestBidsPerBidderCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getBidderStatsExcel()` */
  static readonly GetBidderStatsExcelPath = '/api/bidders/auction/{auctionId}/bidder-stats-excel';

  /**
   * Gets an Excel export of bidder statistics for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidderStatsExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStatsExcel$Response(params: GetBidderStatsExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getBidderStatsExcel(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an Excel export of bidder statistics for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidderStatsExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStatsExcel(params: GetBidderStatsExcel$Params, context?: HttpContext): Observable<Blob> {
    return this.getBidderStatsExcel$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
